/* @flow */

import React from 'react'

import type { Icon, IconsQuery } from '../types'

import { DEFAULT_ICON_SIZE } from '../stores/iconsStore'

import Search from './Search'
import Condition from './Condition'

type Props = {
  location: Object,
  items: Array<Icon>,
  query: IconsQuery,
  isFetching: boolean,

  goToPreviousPage: (location: Object) => void,
  goToNextPage: (location: Object) => void,
  updateSearch: (location: Object, search: string) => void,
  onClick?: (icon: Icon) => void,
}

export default function IconTable(props: Props) {
  function updateSearch(search: string) {
    props.updateSearch(props.location, search)
  }

  return (
    <div>
      {(() => {
        if (props.isFetching && props.items.length === 0) {
          return (
            <div>fetching all icons initially. this can take a moment.</div>
          )
        }

        return (
          <div className="ph4">
            <Condition shouldRender={props.isFetching}>
              <div>fetching the newest icons for you</div>
            </Condition>

            <Search value={props.query.search} onChange={updateSearch} />

            <ul className="icon-list">
              {props.items.map(item => {
                const style = {}
                style.width = DEFAULT_ICON_SIZE
                style.height = DEFAULT_ICON_SIZE
                style.borderRadius = '100%'
                if (props.onClick != null) {
                  style.cursor = 'pointer'
                }

                if (item.customer == null) {
                  throw new Error('missing .customer on icon')
                }

                function onClick() {
                  if (props.onClick != null) {
                    props.onClick(item)
                  }
                }

                return (
                  <li key={item.id} onClick={onClick}>
                    <div>
                      <img alt="icon" style={style} src={item.url} />
                    </div>
                    <div className="tc">{item.name}</div>
                  </li>
                )
              })}
            </ul>
          </div>
        )
      })()}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/IconTable.js